import { render, staticRenderFns } from "./AbkSurveyQuestionChoose.vue?vue&type=template&id=2b5d47c3&scoped=true&"
import script from "./AbkSurveyQuestionChoose.vue?vue&type=script&lang=js&"
export * from "./AbkSurveyQuestionChoose.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveyQuestionChoose.vue?vue&type=style&index=0&id=2b5d47c3&lang=scss&scoped=true&"
import style1 from "./AbkSurveyQuestionChoose.vue?vue&type=style&index=1&id=2b5d47c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5d47c3",
  null
  
)

export default component.exports